export default "__VITE_ASSET__15f606de__"